module.exports = __webpack_public_path__ + "img/payment-type-diners-club.9b90bbf9.svg";